import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  updateTelegramSettings,
  testTelegramSettings,
  UpdateTelegramSettingsParams,
  TelegramSettings,
  TelegramBotSlot,
} from "@/api/settings/telegram";
import { SettingsQueryKeys } from "@/tanstackQuery/queries/settings";

export interface UpdateTelegramSettingsOptions {
  onSuccess?: (data: TelegramSettings) => void;
  onError?: (error: Error) => void;
}

// A successful save refreshes the (masked) settings so the token fields show
// the newly stored token; fire-and-forget so the caller's toast fires at once.
export const useUpdateTelegramSettings = (
  options?: UpdateTelegramSettingsOptions
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateTelegramSettingsParams) =>
      updateTelegramSettings(params),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [SettingsQueryKeys.Telegram],
      });
      options?.onSuccess?.(data);
    },
    onError: options?.onError,
  });
};

export interface TestTelegramSettingsOptions {
  onSuccess?: (data: void, bot: TelegramBotSlot) => void;
  onError?: (error: Error) => void;
}

export const useTestTelegramSettings = (
  options?: TestTelegramSettingsOptions
) => {
  return useMutation({
    mutationFn: (bot: TelegramBotSlot) => testTelegramSettings(bot),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
};
